import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbUpFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 3.5 21 13h-5.5v7.5h-7V13H3z" })
});
export default SvgThumbUpFill;
